import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import Grid from '../../components/GridView'

const query = gql`
  query document($id: ID!) {
    document(id: $id) {
      id
      cod
      type

      chain {
        id
        cod
        type
        due_date
        insurer {
          id
          cod
          name
        }
      }
    }
  }
`
const withQuery = graphql(query, {
  options: ({ row }) => ({
    variables: { id: row.id }
  })
})

export default compose(
  withQuery,
  withProps(({ data }) => {
    // console.log(data)

    return {
      columns: [
        { name: 'type', title: 'Tipo' },
        { name: 'cod', title: 'Código' },
        {
          name: 'insurer',
          title: 'Seguradora',
          getCellValue: row =>
            (row.insurer && row.insurer.cod) || row.metadata.insurer
        },
        { name: 'due_date', title: 'Vencimento', sort: 'desc', type: 'date' },
        {
          name: 'id',
          label: 'editar',
          to: '/documents',
          title: ' ',
          type: 'link'
        }
      ],
      extensions: [
        { columnName: 'type', width: 100, align: 'center' },
        { columnName: 'due_date', width: 150, align: 'center' },
        { columnName: 'id', width: 75, align: 'center' }
      ],

      dense: true,
      loading: data.loading,
      rows: (data.document && data.document.chain) || []
    }
  })
)(Grid)
